import { render, staticRenderFns } from "./GdCustomRadio.vue?vue&type=template&id=cbb9281e"
import script from "./GdCustomRadio.vue?vue&type=script&lang=js"
export * from "./GdCustomRadio.vue?vue&type=script&lang=js"
import style0 from "./GdCustomRadio.vue?vue&type=style&index=0&id=cbb9281e&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports